export const SCHEDULE_REPORT_API =
  process.env.REACT_APP_SCHEDULE_REPORT_API ||
  "https://ehjfx3o38b.execute-api.us-east-1.amazonaws.com/prod/schedule_report";

export const GET_REPORT_API =
  process.env.REACT_APP_GET_REPORT_API ||
  "https://ehjfx3o38b.execute-api.us-east-1.amazonaws.com/prod/get_report";
